import React from 'react';
import { TezinaPitanja } from '../../../model/enum/tezina-pitanja.enum';

export const TezinaSelectedList = [
    { title: 'Lako', value: TezinaPitanja.LAKO, color: '#a5d6a7', borderColor: '#1b5e20', lighColor: '#c8e6c9' },
    { title: 'Srednje', value: TezinaPitanja.SREDNJE, color: '#ce93d8', borderColor: '#4a148c', lighColor: '#e1bee7' },
    { title: 'Teško', value: TezinaPitanja.TESKO, color: '#e57373', borderColor: '#b71c1c', lighColor: '#ffcdd2' },
];

interface LovacKvizStartScreenProps {
    selectedTezina: number;
    setSelectedTezina: (value: number) => void;
    onStart: () => void;
    onStartTakmicarski: () => void;
    onRangLista: () => void;
    isSignedIn: boolean;
    samoTakmicarski?: boolean;
}

const LovacKvizStartScreen: React.FC<LovacKvizStartScreenProps> = ({
    selectedTezina,
    setSelectedTezina,
    onStart,
    onStartTakmicarski,
    onRangLista,
    isSignedIn,
    samoTakmicarski,
}) => {
    if (samoTakmicarski) {
        return (
            <div className="w-full min-h-full bg-white flex flex-col py-[30px] rounded-[10px] mt-5">
                <div className="grid grid-cols-12 md:grid-cols-10 ">
                    <div className="col-span-11 md:col-span-9 bg-blueDark rounded-r-full p-3 flex flex-col md:flex-row items-center justify-between gap-3 border-[2px] border-gold">
                        <div className="flex flex-col">
                            <p className="text-gold text-[24px] leading-7 font-bold">Kviz Lovac - Takmičarski</p>
                            <p className="text-white text-[16px] leading-5 font-medium">
                                Meri se vreme od početka do vrha piramide, pitanja su sve teža kako se penješ. Rezultat ulazi u rang listu samo ako stigneš do
                                vrha.
                                {!isSignedIn && ' Potrebno je da budeš ulogovan.'}
                            </p>
                        </div>
                        <div className="flex flex-row gap-3 shrink-0">
                            <button
                                onClick={onRangLista}
                                className="px-4 h-[44px] rounded-lg border-[2px] border-gold text-gold font-semibold whitespace-nowrap"
                            >
                                Rang lista
                            </button>
                            <button onClick={onStartTakmicarski} className="px-4 h-[44px] rounded-lg bg-gold text-blueDark font-bold whitespace-nowrap">
                                Takmiči se
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="w-full min-h-full bg-white flex flex-col py-[30px] rounded-[10px] mt-5">
            <div className="grid grid-cols-12 md:grid-cols-10 ">
                <div className="col-span-11 md:col-span-9  bg-greyMedium rounded-r-full p-3 flex flex-row items-center justify-between">
                    <div className="flex flex-col">
                        <p className="text-white text-[24px] leading-7 font-bold">Kviz Lovac</p>
                        <p className="text-white text-[16px] leading-5 font-medium">
                            Igrač ima tri života i cilj je da se tačnim odgovorima popne na vrh piramide. Registrovani korisnici prelaze na sledeći nivo i
                            dobijaju nova, neponovljiva pitanja.
                        </p>
                    </div>
                    <button onClick={onStart} className="start-button">
                        Pokreni kviz
                    </button>
                </div>
            </div>
            <div className="mt-7">
                <p className="text-blueMedium text-[36px] leading-10 font-bold text-center" style={{ fontFamily: 'RubikDoodleShadow' }}>
                    Odaberite nivo težine pitanja
                </p>
            </div>
            <div className="w-full flex flex-col items-center gap-[14px] mt-7">
                {TezinaSelectedList.map((item: any, index: number) => (
                    <button
                        key={index}
                        className="w-[250px] max-w-[250px] min-h-[50px] flex flex-row items-center justify-center gap-5 px-6 rounded-[15px] transition border-[3px]"
                        style={{
                            backgroundColor: selectedTezina === item.value ? item.lighColor : item.color,
                            borderColor: selectedTezina === item.value ? item.borderColor : item.color,
                            transform: selectedTezina === item.value ? 'scale(1.15)' : 'scale(1)',
                            opacity: selectedTezina === item.value ? 1 : 0.7,
                        }}
                        onClick={() => setSelectedTezina(item.value)}
                    >
                        <p
                            className="text-grey-900 text-[36px] leading-[40px] font-bold text-center"
                            style={{
                                fontFamily: 'RubikDoodleShadow',
                                color: item.borderColor,
                            }}
                        >
                            {item.title}
                        </p>
                    </button>
                ))}
            </div>
        </div>
    );
};

export default LovacKvizStartScreen;
